import { render, staticRenderFns } from "./TableFieldGroupsContainer.vue?vue&type=template&id=2f633d2b&scoped=true&"
import script from "./TableFieldGroupsContainer.vue?vue&type=script&lang=js&"
export * from "./TableFieldGroupsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f633d2b",
  null
  
)

export default component.exports